import NotificationTypes from '~/constants/types/NotificationTypes';

var cachedAction = null;

export default function confirmationHandler() {
  return next => action => {
    const {confirmationRequired, notification} = action.meta || {};
    if (confirmationRequired) {
      // Cache the action for later
      cachedAction = action;
      // Dispatch notification action instead of the original action
      return next({
        type: NotificationTypes.ERROR,
        payload: notification
      });
    } else if (action.type === NotificationTypes.CONFIRM && cachedAction) {
      // Reset the cached action
      const nextAction = cachedAction;
      cachedAction = null;
      // Dispatch cached action
      next(nextAction);
    }
    return next(action);
  };
}
